import React, { useState, useEffect } from "react";
import {LogEvent} from '@learningblocks/storybook-components';
import PropTypes from "prop-types";
import { StartIcon } from "./StartIcon";
import { LevelButton } from "./LevelButton";
import { StartSimulationButton } from "./StartSimulationButton";

import Level_one_icon from "./img/Level_one.svg";
import Level_two_icon from "./img/Level_two.svg";
import Level_three_icon from "./img/Level_three.svg";

import "./style.scss";

/**
 * Contents displayed inside LevelSelection Modal Window of Experimental-Design.
 */
export function LevelSelector(props) {
  const [simulationLevels, updateSimulationLevels] = useState([]);

  useEffect(() => {
    updateSimulationLevels(
      makeSimulationlevelList(props.defaultSelected)(props.simulationLevels)
    );
  }, []);

  function updateSelectedLevel(id) {
    updateSimulationLevels((levelList) =>
      makeSimulationlevelList(id)(levelList)
    );
  }

  const getLevelIcon = (level) => {

    let icon = Level_one_icon

    switch(level.id){
      case 1:
        icon = Level_one_icon;
        break;
      case 2:
        icon = Level_two_icon;
        break;
      case 3:
        icon = Level_three_icon;
        break;
    }

    return icon
  }

  const renderLevelButtons = () =>
    simulationLevels.map((level) => (
      <LogEvent
        logEventProps={{
          event_type: "sim_level selected",
          event_schema: "track",
          level: level.id,
          section: "level"
        }}
        actionProps={{ onClick: { action: 'click' } }}
        elementType="button"
      >
        <LevelButton
          key={level.id}
          onClick={updateSelectedLevel}
          className="level-selection__levelbutton"
          levelID={level.id}
          selected={level.selected}
          >
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div style={{ display: "flex", background: "#003e6b", borderRight: "1px solid white" }}>
                <img src={getLevelIcon(level)} alt={level.label}/>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  padding: "16px",
                }}
              >
                <h2 style={{ margin: 0 }}>{level.label}</h2>
                <p style={{ margin: "8px 0 0" }}>{level.description}</p>
              </div>
            </div>
        </LevelButton>
      </LogEvent>
    ));

  const setLevel = (event) => {
    event.preventDefault();
    props.setLevel(getSelectedLevel(simulationLevels));
  };

  const getCurrentLevel = () => {
    let dict = ["one", "two", "three"];
    let currentLevelIndex = -1;

    simulationLevels.forEach((level, index) => {
      if (level.selected) {
        currentLevelIndex = index;
      }
    });

    return dict[currentLevelIndex];
  };

  const getCurrentLevelId = () => {
    let currentLevelId = -1;

    simulationLevels.forEach((level, index) => {
      if (level.selected) {
        currentLevelId = level.id;
      }
    });

    return currentLevelId;
  };


  return (
    <main>
      <div className="level-selection">
        <div className="level-selection__title">
          <h1 id="heading">Select a level</h1>
        </div>
        {renderLevelButtons()}
        <div className="level-selection__submit">
          <LogEvent
            logEventProps={{
              event_type: "sim_level started",
              event_schema: "track",
              level: getCurrentLevelId(),
              section: "level"
            }}
            actionProps={{ onClick: { action: 'click' } }}
            elementType="button"
          >
            <StartSimulationButton onClick={setLevel}>
              <StartIcon />
              {"Start level " + getCurrentLevel()}
            </StartSimulationButton>
          </LogEvent>
        </div>
      </div>
    </main>
  );
}

LevelSelector.propTypes = {
  /**
   * List of levels for the simultion
   */
  simulationLevels: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
  /**
   * Button to be selectedBy default
   */
  defaultSelected: PropTypes.number.isRequired,
  /**
   * Callback function to be executed when you click the Start Simulation Button
   */
  setLevel: PropTypes.func.isRequired,
};

LevelSelector.defaultProps = {
  simulationLevels: [],
  defaultSelected: 0,
};

function makeSimulationlevelList(selectedID) {
  return function (levelList) {
    return levelList.map((level) => ({
      ...level,
      selected: selectedID === level.id ? true : false,
    }));
  };
}

function getSelectedLevel(levelList) {
  return levelList.find((level) => level.selected);
}
